var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-[#FF9500] w-full mx-auto",class:_vm.currentPath === '/admin/airport/toulouse/blagnac/agency/checkcode/control'
      ? 'max-w-none'
      : 'max-w-2xl',attrs:{"id":"app"}},[_c('HeaderView'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('FooterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }